module.exports = __webpack_public_path__ + "img/Felton.67473611.svg";